// Combined theme tokens and configuration
import { colors, generateCSSVariables as generateColorVariables } from './colors';
import { typography, generateTypographyCSSVariables } from './typography';
import { spacing, generateSpacingCSSVariables } from './spacing';
import { shadows, generateShadowCSSVariables } from './shadows';
import { borderRadius, generateBorderRadiusCSSVariables } from './borderRadius';

// Default theme configuration
export const defaultThemeConfig = {
  current: 'light',
  available: ['light', 'dark'],
  default: 'light',
  persist: true,
};

// Combined theme tokens
export const themeTokens = {
  colors,
  typography,
  spacing,
  shadows,
  borderRadius,
};

// Generate all CSS custom properties for a theme
export const generateThemeCSSVariables = (theme) => {
  return {
    ...generateColorVariables(theme),
    ...generateTypographyCSSVariables(),
    ...generateSpacingCSSVariables(),
    ...generateShadowCSSVariables(theme),
    ...generateBorderRadiusCSSVariables(),
  };
};

// Theme validation
export const isValidTheme = (theme) => {
  return theme === 'light' || theme === 'dark';
};

// Theme utilities
export const getOppositeTheme = (theme) => {
  return theme === 'light' ? 'dark' : 'light';
};

// Theme persistence utilities
export const THEME_STORAGE_KEY = 'helpdesk-theme';

export const saveThemeToStorage = (theme) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  }
};

export const loadThemeFromStorage = () => {
  if (typeof window !== 'undefined') {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    return isValidTheme(stored) ? stored : null;
  }
  return null;
};

export const clearThemeFromStorage = () => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(THEME_STORAGE_KEY);
  }
};

// Export individual theme tokens for direct access
export { colors };
export { typography };
export { spacing };
export { shadows };
export { borderRadius };

// Export utility functions
export { getShadow, getElevation } from './shadows.js';
export { getBorderRadius } from './borderRadius.js';
export { getSpacing } from './spacing.js';
export { getFontFamily, getFontSize, getFontWeight, getLineHeight } from './typography.js';

export default themeTokens;
